<template>
  <div class="player container">
    <div class="player-container">
      <video id="player" class="video-js vjs-default-skin" controls preload="none" autoplay>
      </video>
      <div id="container"></div>
    </div>
    <div class="player-statistics">
      <div class="statis-item item-offload">
        <span class="item-label">
          <span class="item-label-data">{{statis.offload}}</span> MB<br />
          <span class="item-name offload">Offload</span>
        </span>
      </div>
      <div class="statis-item item-ratio">
        <span class="item-label">
          <span class="item-label-data">{{statis.ratio}}</span> %<br />
          <span class="item-name ratio">P2P Ratio</span>
        </span>
      </div>

      <div class="statis-item item-upload">
        <span class="item-label">
          <span class="item-label-data">{{statis.upload}}</span> MB<br />
          <span class="item-name upload">Upload</span>
        </span>
      </div>

      <div class="statis-item item-rebuffers">
        <span class="item-label">
          <span class="item-label-data">{{statis.buffers}}</span><br />
          <span class="item-name rebuffers">Rebuffers</span>
        </span>
      </div>

      <div class="statis-item item-peers">
        <span class="item-label">
          <span class="item-label-data">{{statis.peers}}</span><br />
          <span class="item-name peers">Peers</span>
        </span>
      </div>

      <div class="statis-item item-peerid">
        <span class="item-label">
          <span class="item-label-data">{{p2pVersion}}</span><br />
          <span class="item-name peerid">Version</span>
        </span>
      </div>

    </div>
    <div class="clear"></div>

    <div class="player-url">
      <div class="player-input">
        <input type="url" :placeholder="this.statis.url" v-on:change="inputChange"/>
        <div class="player-play">
          <a class="button" @click="playVideo">Play</a>
        </div>
      </div>
      <div class="simulate">
        <a class="button" @click="simulate">Simulate Peer</a>
      </div>
    </div>
    <div v-if="!isMobile">
      <h4>The graphs on the bottom represent video segments, showing how much content is delivered via the CDN and how much one tab is downloading from the others.</h4>
    </div>
  </div>
</template>

<script>
import videojs from 'video.js';
// import "video.js/dist/video-js.css";
import shaka from "shaka-player";
import { MediaPlayer } from 'dashjs';
import RxPlayer from "rx-player";
import Hls from 'hls.js';
// import P2pEngineHls from '@swarmcloud/hls'
// import THEOplayer from 'theoplayer';
// const P2pEngineHls = require('@swarmcloud/hls').default
// const P2pEngineHls = require('./p2p-engine.es.min.js')
// console.warn(P2pEngineHls)

import { isMobile, loadScript, loadScripts, getUrlSuffix } from "@/utils/tools";
export default {
  name: 'HLS-Player',
  props: {
    playerType: {
      type: String,
      required: true,
    },
    playerData: {
      type: Object,
      required: true,
      default() {
        return {
          url: '',
          offload: '0',
          ratio: '0',
          upload: '0',
          peers: '0',
          buffers: 0,
          peerID: '',
          engine: null,
        }
      }
    },
  },
  data() {
    return {
      statis: {
        url: '',
        offload: '0',
        upload: '0',
        ratio: '0',
        peers: '0',
        buffers: 0,
        peerID: '',
      },
      p2pVersion: '',
      isMobile: false,
    }
  },
  watch: {
    playerData: {
      handler(val) {
        this.statis = JSON.parse(JSON.stringify(val))
      },
      immediate:true,
      deep: true
    }
  },
  async mounted() {
    this.isMobile = isMobile();
    this.engine = await this.initEngine();
  },
  methods: {
    async initEngine() {
      const video = document.getElementById('player');
      const container = document.getElementById('container');

      var p2pConfig = {
        // trackerZone: 'hk',
        announce: "https://eu.cdnbye.com:2053/v1",
        // logLevel: 'debug',
        // segmentId: function (level, sn, url, range) {
        //     return `${level}-${sn}`
        // },
      };
      let engine;
      switch (this.playerType) {
        case 'videojs':
          // videojs
          engine = await this.initVideojs(video, p2pConfig);
          break;
        case 'shaka':
          // shaka
          engine = await this.initShaka(video, p2pConfig);
          break;
        case 'dashjs':
          // dashjs
          engine = await this.initDashjs(video, p2pConfig);
          break;
        case 'rx':
          // rx-player
          engine = await this.initRxPlayer(video, p2pConfig);
          break;
        case 'bitmovin':
          // bitmovin
          engine = await this.initBitmovin(video, container, p2pConfig);
          break;
        case 'theo':
          // theo
          engine = await this.initTheo(video, container, p2pConfig);
          break;
        case 'mp4':
          // media
          engine = await this.initMedia(video, p2pConfig);
          break;
        default:
          // hlsjs
          engine = await this.initHlsjs(video, p2pConfig);
          break
      }
      this.setupListener(engine);
      return engine
    },
    simulate() {
      window.open(`${window.location.origin}${window.location.pathname}?url=${encodeURIComponent(this.statis.url)}&player=${this.playerType}`)
    },
    playVideo() {
      // videojs("player").src([{ type: "application/x-mpegURL", src: this.statis.url }])
      // videojs("player").play()
      window.open(`${window.location.origin}${window.location.pathname}?url=${encodeURIComponent(this.statis.url)}&player=${this.playerType}`, '_self')
    },
    inputChange(e) {
      this.statis.url = e.target.value
    },
    setupListener(engine) {
      engine.on('stats', this.$parent.onStats);
      engine.on('peerId', this.$parent.onPeerID);
      engine.on('peers', this.$parent.onPeers);
      engine.on('httpDownloaded', this.$parent.onHttpDownloaded);
      engine.on('p2pDownloaded', this.$parent.onP2pDownloaded);
      engine.on('bufferStalled', this.$parent.onRebuffer);
    },
    async initVideojs(video, p2pConfig) {
      await loadScript('//cdn.jsdelivr.net/npm/@swarmcloud/vhs');
      this.p2pVersion = P2pEngineVHS.version;
      var options = {
        autoplay: true,
        sources:[
          {
            src: this.statis.url,
          },
        ],
        vhs: {
          overrideNative: true        // Enable p2p if the platform supports Media Source Extensions
        },
      };
      var player = videojs(video, options);
      return new P2PEngineVHS(player, p2pConfig, videojs)
    },
    async initMedia(video, p2pConfig) {
      await loadScript('//cdn.jsdelivr.net/npm/@swarmcloud/media');
      this.p2pVersion = P2PEngineMedia.version;
      var engine = new P2PEngineMedia(p2pConfig)
      // get the proxied playback url
      engine.getProxiedUrl(this.statis.url).then((url) => {
        video.src = url;
      })
      return engine
    },
    // async initTheo(video, container, p2pConfig) {
    //   await loadScript('//cdn.jsdelivr.net/npm/@swarmcloud/theoplayer');
    //   video.remove()
    //   this.p2pVersion = P2pEngineTheo.version;
    //   var player = new THEOplayer.Player(container, {
    //     libraryLocation: "https://cdn.myth.theoplayer.com/c195a0cd-3811-40c6-80d7-384f09506239",
    //     ui: {
    //       width: "512px",
    //       height: "288px",
    //     },
    //     liveOffset: 30,
    //   });
    //   player.source = {
    //     sources: [
    //       {
    //         src: this.statis.url,  // range
    //       },
    //     ],
    //   };
    //   return new P2pEngineTheo(player, p2pConfig);
    // },
    async initBitmovin(video, container, p2pConfig) {
      await loadScripts(['//cdn.jsdelivr.net/npm/@swarmcloud/bitmovin', '//cdn.jsdelivr.net/npm/bitmovin-player@8/bitmovinplayer.js']);
      video.remove()
      var conf = {
        key: '88279505-ea35-4ba5-870b-e9c7978bccf9',
        playback: {
          autoplay: true,
          muted: true,
          preferredTech: [
            {player: 'html5', streaming: 'hls'}
          ]
        },
        live:{
          lowLatency:{
            targetLatency: 30
          }
        },
      };
      this.p2pVersion = P2pEngineBitmovin.version;
      var engine = new P2pEngineBitmovin(p2pConfig);
      conf.network = engine.getNetworkConfig();
      var player = new bitmovin.player.Player(container, conf);
      const suffix = getUrlSuffix(this.statis.url);
      var source = {};
      if (suffix === 'm3u8') {
        source.hls = this.statis.url;
      } else {
        source.dash = this.statis.url;
      }
      engine.setPlayer(player);
      player.load(source);
      return engine
    },
    async initRxPlayer(video, p2pConfig) {
      await loadScript('//cdn.jsdelivr.net/npm/@swarmcloud/rx-player');
      this.p2pVersion = P2pEngineRxPlayer.version;
      const rxPlayer = new RxPlayer({
        videoElement: video
      });
      var rxConfig = {
        url: this.statis.url,
        transport: "dash",
        autoPlay: true,
      }
      var engine = new P2pEngineRxPlayer(rxPlayer, p2pConfig)
      rxPlayer.loadVideo(rxConfig);
      return engine
    },
    async initDashjs(video, p2pConfig) {
      await loadScript('//cdn.jsdelivr.net/npm/@swarmcloud/dashjs');
      this.p2pVersion = P2PEngineDash.version;
      let player = MediaPlayer().create();
      player.initialize(video, this.statis.url, true);
      return new P2PEngineDash(player, p2pConfig);
    },
    async initShaka(video, p2pConfig) {
      await loadScript('//cdn.jsdelivr.net/npm/@swarmcloud/shaka');
      this.p2pVersion = P2PEngineShaka.version;
      shaka.polyfill.installAll();
      const player = new shaka.Player();
      player.attach(video);
      var engine = new P2PEngineShaka(player, p2pConfig, shaka);
      player.load(this.statis.url);
      return engine
    },
    async initHlsjs(video, p2pConfig) {
      await loadScript('//cdn.jsdelivr.net/npm/@swarmcloud/hls/p2p-engine.min.js');
      this.p2pVersion = P2pEngineHls.version;
      var hls = new Hls();
      p2pConfig.hlsjsInstance = hls;        // set hlsjs instance to SDK
      var engine = new P2pEngineHls(p2pConfig);
      hls.loadSource(this.statis.url);
      hls.attachMedia(video);
      hls.on(Hls.Events.MANIFEST_PARSED,function() {
        video.play();
      });
      return engine
    },
  }
}
</script>

<style>
  .player-url {
    margin-top: 50px;
    width: 100%;
    height: 40px;
  }
  .player-input {
    width: 80%;
    height: 100%;
    float: left;
  }
  .player-input input {
    width: 84%;
    height: 40px;
    padding: 6px 12px;
    font-size: 16px;
    color: #555;
    background-color: #fff;
    background-image: none;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
    box-sizing: border-box;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .simulate {
    float: right;
    width: 15%;
    height: 100%;
  }
  .player-play {
    width: 15%;
    height: 100%;
    display: inline-block;
  }
  .player-play a {
    width: 100%;
    padding: 6px 12px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  .player {
    height: 490px;
    margin-top: 50px !important;
    font-family: "AltGotNo3D", "Source Sans Pro", sans-serif;
  }
  .player-container {
    float: left;
    width: 64%;
  }
  #player {
    width: 100%;
    height: 400px;
  }
  .player-statistics {
    float: right;
    width: 30%;
    height: 400px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
  }
  .clear {
    clear: both;
  }
  .statis-item {
    position: relative;
    width: 120px;
    height: 120px;
    border-radius: 50%;
    box-sizing: border-box;
    margin: 0 auto;
  }

  .item-label {
    position: absolute;
    top: 35%;
    left: 0.4rem;
    right: 0.4rem;
    text-align: center;
    line-height: 30px;
  }
  .item-label-data {
    font-size: 1.5rem;
    font-weight: 600;
    color: rgb(10, 55, 88);
    font-family: "AltGotNo3D", "Source Sans Pro", sans-serif !important;
  }
  .item-name {
    line-height: 24px;
    font-size: .875rem !important;
    font-weight: 500 !important;
    color: #fff !important;
    padding: 2px 5px;
    border-radius: 5px;
  }

  .item-offload {
    border: 0.05em solid #5cb85c;
  }
  .item-ratio {
    border: 0.05em solid #3c8105;
  }
  .item-peers {
    border: 0.05em solid #5bc0de;
  }
  .item-rebuffers {
    border: 0.05em solid #d9534f;
  }
  .item-upload {
    border: 0.05em solid #337ab7;
  }
  .item-peerid {
    border: 0.05em solid #f0ad4e;
  }
  /*.item-peerid .item-label {*/
    /*line-height: 16px !important;*/
  /*}*/
  /*.item-peerid span {*/
    /*font-size: 0.85rem !important;*/
    /*word-wrap: break-word !important;*/
  /*}*/

  .offload {
    background-color: #5cb85c;
  }
  .ratio {
    background-color: #3c8105;
  }
  .peers {
    background-color: #5bc0de
  }
  .rebuffers {
    background-color: #d9534f
  }
  .peerid {
    background-color: #d9534f
  }
  .upload {
    background-color: #337ab7;
  }
  .peerid {
    background-color: #f0ad4e;
  }



</style>
